
import api from "@/api/cloud";

const getInitState = () => ({
	communityId: null,
	operatorId: null,
	systemId: null,
});

export default {
	namespaced: true,
	state: getInitState(),

	getters: {
		community: (state, getters, rootState, rootGetters) =>
			rootGetters["communities/itemById"](state.communityId),

		system: (state, getters, rootState, rootGetters) =>
			rootGetters["rooms/item"](state.systemId),
	},

	mutations: {
		async setCommunityId(state, communityId) {
			
			if (communityId && state.communityId !== communityId) {
				this._vm.$log(`Session: Community selected ${communityId}`);
				await api.switchCommunity(communityId);
			}

			state.communityId = communityId;

		},

		async setOperatorId(state, operatorId) {
			
			if (operatorId && state.operatorId !== operatorId) {
				this._vm.$log(`Session: Operator selected ${operatorId}`);
				await api.switchOperator(operatorId);
			}

			state.operatorId = operatorId;

		},

		setSystemId(state, systemId) {
			if (systemId) {
				this._vm.$log(`Session: Room selected`);
			}
			state.systemId = systemId;
		},

		resetState(state) {
			Object.assign(state, getInitState());
		},
	},
	actions: {
		async setCommunityId({commit}, values)
		{

			if(values)
			{
				const { id, operator } = values;
				await commit('setOperatorId', operator);
				await commit('setCommunityId', id);
			} else {
				await commit('setOperatorId', null);
				await commit('setCommunityId', null);
			}
			
		}

	}
};
